import axios from "axios";
import {getConfig} from '../helpers/config';

export class NazioneService {

	baseAPIUrl = `${getConfig()?.url}nazioni`;

	getAll = async () => {
		return await axios.get(`${this.baseAPIUrl}/`)
											.then(res => res.data);
	}
}
